var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.reservations_by_states),function(state,key){return _c('div',{key:key},[(state.length > 0)?_c('div',[_c('div',{staticClass:"mb-3 text-xl"},[_vm._v(_vm._s(key))]),_vm._l((state),function(reservation,key){return _c('Reservation',{key:key,attrs:{"data":reservation}})})],2):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }